import { render, staticRenderFns } from "./list.vue?vue&type=template&id=32502f89&scoped=true"
import script from "./list.vue?vue&type=script&lang=js"
export * from "./list.vue?vue&type=script&lang=js"
import style0 from "./list.vue?vue&type=style&index=0&id=32502f89&prod&lang=scss&scoped=true"
import style1 from "./list.vue?vue&type=style&index=1&id=32502f89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32502f89",
  null
  
)

export default component.exports